import { ApolloLink } from '@apollo/client/core';

export default function () {
  return new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
      return response;
    });
  });
}
